import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MobileFooter from './components/MobileFooter';
import FloatingCTA from './components/FloatingCTA';
import Locations from './components/Locations';


// Temporary API Test Component

import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ServicesPage from './pages/ServicesPage';
import TherapyDetail from './pages/TherapyDetail';
import TherapiesPage from './pages/TherapiesPage';
import CoursesPage from './pages/CoursesPage';
import GalleryPage from './pages/GalleryPage';
import VideosPage from './pages/VideosPage';
import TestimonialsPage from './pages/TestimonialsPage';
import FAQPage from './pages/FAQPage';
import BlogPage from './pages/BlogPage';
import BlogDetail from './pages/BlogDetail';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import CookiePolicyPage from './pages/CookiePolicyPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white selection:bg-emerald-500 selection:text-white flex flex-col">
        <Header />
        <main className="flex-grow pt-[80px] lg:pt-[80px] pb-20 lg:pb-0">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/therapies" element={<TherapiesPage />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/therapy/:slug" element={<TherapyDetail />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        
        {/* Global Locations - rendered on every page above footer */}
        <Locations />
        <MobileFooter />
        <Footer />
        <FloatingCTA />
     
      </div>
    </Router>
  );
}

export default App;